import React from "react";
import InformTable from "../Components/InformTable";
import { HistoryAction } from "../HistoryActionModel";
import { buildModifiedTableData } from "../utils/historyActionHelpers";

const formatProductValue = (property: string, value: any): string | null => {
    if (value === null || value === undefined) return null;
    if (["IsFree", "IsTrial", "HasLifeTime"].includes(property)) return value ? "Yes" : "No";
    return String(value);
};

const ProductUpdated: React.FC<{ action: HistoryAction }> = ({ action }) => {
    const { dataOld, dataNew } = buildModifiedTableData(action.Changes, formatProductValue);

    return (
        <div className="inform_panel">
            <InformTable data={dataOld} label="Old Version" />
            <InformTable data={dataNew} label="New Version" />
        </div>
    );
};

export default ProductUpdated;
